var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"e6a7ee1c-5750-48ed-b29c-af22387af8e9","data-name":"Path 2335","d":"M19.34227,67.56158a3.44293,3.44293,0,0,0,1.894-.62988L41.13622,48.92388A2.91182,2.91182,0,1,0,37.39256,44.463c-.01635.01269-.03247.02734-.04834.041l-15.7871,14.5293q.62475-8.21778.78491-17.84668.15892-9.646.16308-16.74414,0-5.75976-.10791-14.22559h0l-.2-7.35742a2.841,2.841,0,1,0-5.68188-.03613v.66894c-.012.13672-.02.27637-.02.42578,0,4.42676.053-5.90039.158,4.09961s.16211,18.73926.16211,26.21387-.21509,14.68848-.637,21.63965a101.18613,101.18613,0,0,0-11.05493-15.166A2.914,2.914,0,1,0,.70458,44.50494h0Q7.96543,52.39313,15.54564,66.294a2.49858,2.49858,0,0,0,3.79663,1.26758Z"}));
}

ArrowDown.defaultProps = {"id":"bfea2451-3b46-4695-8c67-d936fd428f35","data-name":"Layer 1","viewBox":"0 0 42.17642 68.00769"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
